import dayjs from 'dayjs';

export function time(val, output = 'date') {
  let res = '';
  if (!val) {
    return res;
  }
  switch (output) {
    case 'hour': {
      res =
        val.substr(8, 2) + ':' + val.substr(10, 2) + ':' + val.substr(12, 2);
      break;
    }
    case 'date': {
      res = val.substr(0, 4) + '/' + val.substr(4, 2) + '/' + val.substr(6, 2);
      break;
    }
  }
  return res;
}

export function date(val, outputFormat = 'YYYY/MM/DD', inputFormat) {
  if (!val) {
    return '';
  }
  try {
    let day;
    if (val === 'now') {
      day = dayjs();
    } else {
      switch (inputFormat) {
        case 'unix':
          day = dayjs.unix(val);
          break;
        default:
          day = dayjs(val);
      }
    }
    if (outputFormat === 'unix') {
      return day.unix() * 1000;
    }
    if (outputFormat === 'dow') {
      return day.day();
    }
    const result = day.format(outputFormat);
    return result;
  } catch (error) {
    console.log('Date invalid');
    return '';
  }
}
export function dateMs(val, outputFormat = 'YYYY/MM/DD', inputFormat) {
  if (!val) {
    return '';
  }
  try {
    let day;
    if (val === 'now') {
      day = dayjs();
    } else {
      switch (inputFormat) {
        case 'unix':
          day = dayjs(val);
          break;
        default:
          day = dayjs(val);
      }
    }
    if (outputFormat === 'unix') {
      return day.valueOf();
    }
    if (outputFormat === 'dow') {
      return day.day();
    }
    const result = day.format(outputFormat);
    return result;
  } catch (error) {
    console.log('Date invalid');
    return '';
  }
}
